"use strict";
module.exports = function (app) {
    app.factory('BiddingRateIncreaseFactory', ['$http', 'lodash', function ($http, _) {
        //using service instead of socket to ensure the bidding rate always load before checking
        var biddingRate;

        function biddingRateChecker(biddingRate, input) {
            if (biddingRate && input) {
                for (var i = 0; i < biddingRate.length; i += 1) {
                    if (i === biddingRate.length - 1 && input > parseInt(biddingRate[i].to, 10)) {
                        return biddingRate[i]['Increasing bid rate'];
                    } else if (parseInt(biddingRate[i].from, 10) <= input && input < parseInt(biddingRate[i].to, 10)) {
                        return biddingRate[i]['Increasing bid rate'];
                    }
                }
            }
        }

        function biddingRateCheckerReversed(biddingRate, input) {
            if (biddingRate && input) {
                for (var i = 0; i < biddingRate.length; i += 1) {
                    if (i === biddingRate.length - 1 && input > parseInt(biddingRate[i].to, 10)) {
                        return biddingRate[i]['Increasing bid rate'];
                    } else if (parseInt(biddingRate[i].from, 10) < input && input <= parseInt(biddingRate[i].to, 10)) {
                        return biddingRate[i]['Increasing bid rate'];
                    }
                }
            }
        }

        function autoIncreaseBidFn(price)
        {
            return price + parseInt(biddingRateChecker(biddingRate, price), 10);
        }

        $http({
            method: 'GET',
            url: '/data/bidding_rate.json'
            })
            .then(function (response) {
              var data = response.data.result;
              var orderedRates = _.sortByOrder(data, 'from', ['asc']);
              biddingRate = orderedRates;
            });

        return {
            autoIncreaseBidFn: autoIncreaseBidFn,
            amountCount: function amountCount(price) {
                return parseInt(biddingRateChecker(biddingRate, price), 10);
            },
            amountCountReversed: function amountCountReversed(price) {
                return parseInt(biddingRateCheckerReversed(biddingRate, price), 10);
            }
        };
    }]);
};


/*****************
 ** WEBPACK FOOTER
 ** ./shared/js/factory/bidding_rate_increase.factory.js
 ** module id = 82
 ** module chunks = 0
 **/